import { createSlice } from '@reduxjs/toolkit';

import type * as WishlistTypes from './types';

const name = 'wishlistPage';

const initialState: WishlistTypes.WishlistState = {
    showActivitySidebar: true,
    showFiltersSidebar: false,
    showDeleteModal: false,
    showEditModal: false,
    backgroundColor: 'blue',
    wishListModalSlug: null,
    wishListToastSlug: null,
    wishListToastName: null,
    removeWishListToastSlug: null,
    removeWishListToastName: null,
    showUnfollowWishListToast: false,
    showDeleteWishListToast: false,
    showCreateWishListToast: false,
    deleteWishlistName: null,
    wishListModalData: {
        name: undefined,
        image: undefined,
        contract_address: undefined,
        token_id: undefined,
        slug: undefined,
    },
    undoWishlistData: {
        wishlistSlug: undefined,
        contract: undefined,
        tokenId: undefined,
        collectionSlug: undefined,
        chain: undefined,
    },
};

export const wishlistSlice = createSlice({
    name,
    initialState,
    reducers: {
        setShowActivitySidebar(state, { payload }: WishlistTypes.WishlistActivityActionTypes) {
            return { ...state, showActivitySidebar: payload, showFiltersSidebar: false };
        },
        setShowFiltersSidebar(state, { payload }: WishlistTypes.WishlistActivityActionTypes) {
            return { ...state, showFiltersSidebar: payload, showActivitySidebar: false };
        },
        setBackgroundColor(state, { payload }: { payload: string }) {
            return { ...state, backgroundColor: payload };
        },
        setShowDeleteModal(state, { payload }: WishlistTypes.WishlistActivityActionTypes) {
            return { ...state, showDeleteModal: payload };
        },
        setShowEditModal(state, { payload }: WishlistTypes.WishlistActivityActionTypes) {
            return { ...state, showEditModal: payload };
        },
        setWishListModalData(state, { payload }: WishlistTypes.WishlistModalDataActionTypes) {
            return { ...state, wishListModalData: payload };
        },
        setWishListModalSlug(state, { payload }: WishlistTypes.WishlistModalActionTypes) {
            return { ...state, wishListModalSlug: payload };
        },
        setWishListToastSlug(state, { payload }: WishlistTypes.WishlistModalActionTypes) {
            return { ...state, wishListToastSlug: payload };
        },
        setWishListToastName(state, { payload }: WishlistTypes.WishlistModalActionTypes) {
            return { ...state, wishListToastName: payload };
        },
        setRemoveWishListToastName(state, { payload }: WishlistTypes.WishlistModalActionTypes) {
            return { ...state, removeWishListToastName: payload };
        },
        setRemoveWishListToastSlug(state, { payload }: WishlistTypes.WishlistModalActionTypes) {
            return { ...state, removeWishListToastSlug: payload };
        },
        setShowDeleteWishListToast(state, { payload }: WishlistTypes.WishlistActivityActionTypes) {
            return { ...state, showDeleteWishListToast: payload };
        },
        setShowUnfollowWishListToast(state, { payload }: WishlistTypes.WishlistActivityActionTypes) {
            return { ...state, showUnfollowWishListToast: payload };
        },
        setShowCreateWishListToast(state, { payload }: WishlistTypes.WishlistActivityActionTypes) {
            return { ...state, showCreateWishListToast: payload };
        },
        setDeleteWishlistName(state, { payload }: WishlistTypes.WishlistModalActionTypes) {
            return { ...state, deleteWishlistName: payload };
        },
        setUndoWishlistData(state, { payload }: WishlistTypes.WishlistUndoDataActionTypes) {
            return { ...state, undoWishlistData: payload };
        },
    },
});
